import React, { Component } from 'react';
import ShipBoardDetailsModel from '../../../Models/ShipBoardDetailsModel';
import { tarbookService } from '../../../services/tarbook.service';
import { helperText } from '../../../_helpers/helpertext';
import Loader from '../../../_helpers/Loader';
import { isStringEmpty } from '../../../_helpers/string_helper';
import moment from "moment";
const dateFormat = "YYYY-MM-DD";

class addEditShipBoardDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:false,
            shipBoardId:0,
            shipName:'',
            imoNo:'',
            type : [],
            typeValue:'',
            dwt:'',
            mainEngineMake:'',
            mainEngineType:'',
            mainEnginePower:'',
            auxEngineMake:'',
            auxEngineType:'',
            auxEnginePower:'',
            auxBoilerMake :'',
            auxBoilerType :'',
            auxBoilerPower:'',
            joiningDate:'',
            leavingDate:'',
            days:0,
            errorMessage: {},
            showSucessMessage:false,
            showFailureMessage:false,
            newRecord:false,
            userId:0,
        };
    }

    componentDidMount() {
        const id = this.props.shipBoardId;
        const userID = localStorage.getItem("UserID");
        this.setState({
            shipBoardId:id,
            userId:userID,
        })
        if(id == 0){
            this.setState({newRecord:true});
        }else{
            this.setState({newRecord:false});
        }
        this.getTypeValues();

        if(id !== 0){
            this.getIndivisualShipDetail(id);
        }
    }

    /* <summary>
    date: 14-07-2022
    Name: VD
    description: This is used to get the list of all type to bind in the dropdown
    <summary>*/ 
    getTypeValues=async()=>{
        try{
            this.setState({isLoading:true});

            var response = await tarbookService.GetTypeValues();
            if(response.status === 200){
                this.setState({
                    type : response.data,
                })
            }
            this.setState({isLoading:false});
        }
        catch(ex){
            return "";
        }
    }

    /* <summary>
    date: 14-07-2022
    Name: VD
    description: This is used to get the indivisual Ship details based on the ship detail id
    <summary>*/ 
    getIndivisualShipDetail=async(id)=>{
        try{
            this.setState({isLoading:true});

            var response = await tarbookService.GetIndivisualShipDetail(id);
            if(response.status === 200 ){
                this.setState({
                    shipBoardId:response.data.shipBoardId,
                    shipName:response.data.shipName,
                    imoNo:response.data.imoNo,
                    typeValue:response.data.type,
                    dwt:response.data.dwt,
                    mainEngineMake:response.data.mainEngineMake,
                    mainEngineType:response.data.mainEngineType,
                    mainEnginePower:response.data.mainEnginePower,
                    auxEngineMake:response.data.auxEngineMake,
                    auxEngineType:response.data.auxEngineType,
                    auxEnginePower:response.data.auxEnginePower, 
                    auxBoilerMake :response.data.auxBoilerMake,
                    auxBoilerType :response.data.auxBoilerType,
                    auxBoilerPower:response.data.auxBoilerPower, 
                    joiningDate:moment(response.data.joiningDate).format(dateFormat),
                    leavingDate:moment(response.data.leavingDate).format(dateFormat),
                    days:response.data.days,
                })
            }
            this.setState({isLoading:false});
        }
        catch(ex){
            return "";
        }
    }

    onTextChange = (e) => {
        const { name, value } = e.target;
        this.setState({
          [name]: value,
        });
    };

    onDateTextChange=(e)=>{
        const { name, value } = e.target;
        this.setState({
          [name]: value,
        });

        //This is done because the state is not getting set before the date is calulated
        const{joiningDate,leavingDate}=this.state;
        if((name == 'joiningDate' && leavingDate != "") ){
            var joindate = moment(value);
            var leavedate = moment(leavingDate);
            var diff = leavedate.diff(joindate,'days');
            this.setState({
                days : diff
            })
        }else if( name == 'leavingDate' && joiningDate != ""){
            var joindate = moment(joiningDate);
            var leavedate = moment(value);
            var diff = leavedate.diff(joindate,'days');
            this.setState({
                days : diff
            })
        }
    }

    validate=()=>{
        const{
            shipBoardId,
            shipName,
            imoNo,
            typeValue,
            dwt,
            mainEngineMake,
            mainEngineType,
            mainEnginePower,
            auxEngineMake,
            auxEngineType,
            auxEnginePower,
            auxBoilerMake,
            auxBoilerType,
            auxBoilerPower,
            joiningDate,
            leavingDate,
            days,
        }=this.state;

        var isValid = true;
        this.setState({ errorMessage: {} });
        var error = this.state.errorMessage;

        if(isStringEmpty(shipName)){
            error["emptyShipName"] = helperText.shipBoardDetails.emptyShipName;
            this.setState({ errorMessage: error });
            isValid = false;
        }else{
            error["emptyShipName"] = '';
            this.setState({ errorMessage: error });
        }

        if(isStringEmpty(imoNo)){
            error["emptyIMONo"] = helperText.shipBoardDetails.emptyIMONo;
            this.setState({ errorMessage: error });
            isValid = false;
        }else{
            error["emptyIMONo"] = '';
            this.setState({ errorMessage: error });
        }

        if(isStringEmpty(joiningDate)){
            error["emptyJoiningDate"] = helperText.shipBoardDetails.emptyJoiningDate;
            this.setState({ errorMessage: error });
            isValid = false;
        }else{
            error["emptyJoiningDate"] = '';
            this.setState({ errorMessage: error });
        }

        if(isStringEmpty(leavingDate)){
            error["emptyleavingDate"] = helperText.shipBoardDetails.emptyLeavingDate;
            this.setState({ errorMessage: error });
            isValid = false;
        }else{
            error["emptyleavingDate"] = '';
            this.setState({ errorMessage: error });
        }

        return isValid;
    }

    saveShipBoardDetails=async()=>{
        try{
            const{
                shipBoardId,
                shipName,
                imoNo,
                typeValue,
                dwt,
                mainEngineMake,
                mainEngineType,
                mainEnginePower,
                auxEngineMake,
                auxEngineType,
                auxEnginePower,
                auxBoilerMake,
                auxBoilerType,
                auxBoilerPower,
                joiningDate,
                leavingDate,
                days,
                userId
            }=this.state;
            this.setState({isLoading:true});
            if(this.validate()){
                var shipBoardDetails = new ShipBoardDetailsModel();
                shipBoardDetails.shipBoardId = shipBoardId;
                shipBoardDetails.shipName = shipName;
                shipBoardDetails.imoNo = imoNo;
                shipBoardDetails.type = typeValue;
                shipBoardDetails.dwt = dwt;
                shipBoardDetails.mainEngineMake = mainEngineMake;
                shipBoardDetails.mainEngineType = mainEngineType;
                shipBoardDetails.mainEnginePower = mainEnginePower;
                shipBoardDetails.auxEngineMake = auxEngineMake;
                shipBoardDetails.auxEngineType = auxEngineType;
                shipBoardDetails.auxEnginePower = auxEnginePower;
                shipBoardDetails.auxBoilerMake = auxBoilerMake;
                shipBoardDetails.auxBoilerType = auxBoilerType;
                shipBoardDetails.auxBoilerPower = auxBoilerPower;
                shipBoardDetails.joiningDate = joiningDate;
                shipBoardDetails.leavingDate = leavingDate;
                shipBoardDetails.days = days;
                shipBoardDetails.userId = userId;

                var response = await tarbookService.AddEditShipBoardDetails(shipBoardDetails);
                if(response.status === 200){
                    if(response.data != 0){
                        this.setState({
                            showSucessMessage:true,
                            shipBoardId:response.data,
                            // shipName:'',
                            // imoNo:'',
                            // typeValue:'',
                            // dwt:'',
                            // mainEngineMake:'',
                            // mainEngineType:'',
                            // mainEnginePower:'',
                            // auxEngineMake:'',
                            // auxEngineType:'',
                            // auxEnginePower:'',
                            // auxBoilerMake :'',
                            // auxBoilerType :'',
                            // auxBoilerPower:'',
                            // joiningDate:'',
                            // leavingDate:'',
                            // days:'',
                            errorMessage: {},
                        },async()=>{
                            this.props.GetShipBoardDetails();
                        })
                    }else{
                        this.setState({
                            showFailureMessage:true,
                            errorMessage: {},
                        })
                    }
                }
            }
            this.setState({isLoading:false});
        }
        catch(ex){
            return "";
        }
    }

    onCancelClick=()=>{
        if(this.state.shipBoardId == 0){
            this.setState({
                shipBoardId:0,
                shipName:'',
                imoNo:'',
                typeValue:'',
                dwt:'',
                mainEngineMake:'',
                mainEngineType:'',
                mainEnginePower:'',
                auxEngineMake:'',
                auxEngineType:'',
                auxEnginePower:'',
                auxBoilerMake :'',
                auxBoilerType :'',
                auxBoilerPower:'',
                joiningDate:'',
                leavingDate:'',
                days:0,
                errorMessage: {},
                showSucessMessage:false,
                showFailureMessage:false,
            })
        }else{
            this.props.closeModel();
        }
        
    }

    render() {
        const{
            isLoading,
            shipBoardId,
            shipName,
            imoNo,
            type,
            typeValue,
            dwt,
            mainEngineMake,
            mainEngineType,
            mainEnginePower,
            auxEngineMake,
            auxEngineType,
            auxEnginePower,
            auxBoilerMake,
            auxBoilerType,
            auxBoilerPower,
            joiningDate,
            leavingDate,
            days,
            showSucessMessage,
            showFailureMessage,
            newRecord,
        }=this.state;
        return (
            <div className="modal update-unit-popup" id="myModal">
                {isLoading && <Loader />}
                <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    {/* Modal Header */}
                    <div className="modal-header" style={{padding:'6px 1rem'}}>
                    <h4 className="modal-title">Ship Board Details - {shipBoardId == 0 ?"Add":"Edit"} Record</h4>
                    <button type="button" data-bs-dismiss="modal" onClick={()=>this.props.closeModel()} className="btn-close">X</button>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body" style={{padding:'12px 1rem'}}>
                        <div className="mb-2">
                        <label htmlFor="name">Ship Name</label>
                        <input 
                            type="Name" 
                            className="form-control" 
                            id="name" 
                            name="shipName"
                            value={shipName} 
                            onChange={this.onTextChange}
                        />
                        <div className="error-message col-md-12 col-lg-9"   style={{ display: this.state.errorMessage.emptyShipName ? "contents" : "none",color: "red" }}>
                            <div style={{paddingLeft:"0px",marginTop:'0px'}}> {this.state.errorMessage.emptyShipName}</div>
                        </div>
                        </div>
                        <div className="mb-2 mt-2">
                        <div className="row">
                            <div className="col-md-4 col-4">
                            <label htmlFor="IMOnumber">IMO No.</label>
                            <input 
                                type="Number" 
                                className="form-control" 
                                id="IMOno" 
                                name="imoNo"
                                value={imoNo} 
                                onChange={this.onTextChange}
                            />
                            
                            <div className="error-message col-md-12 col-lg-9"   style={{ display: this.state.errorMessage.emptyIMONo ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"0px",marginTop:'0px'}}> {this.state.errorMessage.emptyIMONo}</div>
                            </div>
                            </div>
                            <div className="col-md-4 col-4">
                            <label htmlFor="Type">Type</label>
                            <select 
                                className="form-select form-select-lg mb-3 modal-select" 
                                aria-label=".form-select-lg example"
                                value={typeValue} 
                                name="typeValue"
                                onChange={this.onTextChange}
                            >
                                
                                {type.map((item)=>{
                                    return(
                                        <option value={item.typeName}>{item.typeName}</option>  
                                    )
                                })}
                            </select>
                            </div>
                            <div className="col-md-4 col-4">
                            <label htmlFor="DWT">DWT</label>
                            <input 
                                type="Name" 
                                className="form-control" 
                                id="DWT" 
                                name="dwt"
                                value={dwt} 
                                onChange={this.onTextChange}
                            />
                            </div>
                        </div>
                        <table className="table table-responsive">
                            <tbody>
                            <tr>
                                <td className="engine-type" />
                                <td><label htmlFor="Make" className="mb-2">Make</label></td>
                                <td><label htmlFor="Type" className="mb-2">Type</label></td>
                                <td><label htmlFor="Power" className="mb-2">Power</label></td>
                            </tr>
                            <tr>
                                <td><label htmlFor="MainEngine" className="mb-2">Main Engine</label></td>
                                <td><input 
                                        type="Name" 
                                        className="form-control mb-2" 
                                        id="Make" 
                                        value={mainEngineMake} 
                                        name="mainEngineMake"
                                        onChange={this.onTextChange} 
                                    /></td>
                                <td>
                                    <input 
                                        type="Name" 
                                        className="form-control mb-2" 
                                        id="Type" 
                                        value={mainEngineType} 
                                        name="mainEngineType"
                                        onChange={this.onTextChange}  
                                    />
                                </td>
                                <td>
                                    <input 
                                        type="Name" 
                                        className="form-control mb-2" 
                                        id="Power" 
                                        value={mainEnginePower} 
                                        name="mainEnginePower"
                                        onChange={this.onTextChange}   
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="AuxEngine" className="mb-3">Aux. Engine</label></td>
                                <td><input type="Name" className="form-control mb-2" id="Make" 
                                        value={auxEngineMake} 
                                        name="auxEngineMake"
                                        onChange={this.onTextChange}   
                                    /></td>
                                <td><input type="Name" className="form-control mb-2" id="Type" 
                                        value={auxEngineType} 
                                        name="auxEngineType"
                                        onChange={this.onTextChange}    /></td>
                                <td><input type="Name" className="form-control mb-2" id="Power" 
                                        value={auxEnginePower} 
                                        name="auxEnginePower"
                                        onChange={this.onTextChange} /></td>
                            </tr>
                            <tr>
                                <td><label htmlFor="AuxBoiler">Aux. Boiler</label></td>
                                <td><input type="Name" className="form-control mb-2" id="Make" 
                                        value={auxBoilerMake} 
                                        name="auxBoilerMake"
                                        onChange={this.onTextChange} /></td>
                                <td><input type="Name" className="form-control mb-2" id="type" 
                                        value={auxBoilerType} 
                                        name="auxBoilerType"
                                        onChange={this.onTextChange} /></td>
                                <td><input type="Name" className="form-control mb-2" id="Power" 
                                        value={auxBoilerPower} 
                                        name="auxBoilerPower"
                                        onChange={this.onTextChange} /></td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                        <div className="mt-2">
                        <div className="row">
                            <div className="col-md-4 col-4">
                            <label htmlFor="Joining-date">Joining Date</label>
                                <input type="date" className="form-control" id="Joining-date" 
                                    value={joiningDate} 
                                    name="joiningDate"
                                    onChange={this.onDateTextChange}
                                    max={leavingDate}
                                />
                                        
                            <div className="error-message col-md-12 col-lg-9"   style={{ display: this.state.errorMessage.emptyJoiningDate ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"0px",marginTop:'0px'}}> {this.state.errorMessage.emptyJoiningDate}</div>
                            </div>
                            </div>
                            <div className="col-md-4 col-4">
                            <label htmlFor="Leave-date">Leaving Date</label>
                            <input type="date" className="form-control" id="Leave-date" 
                                        value={leavingDate} 
                                        min={joiningDate}
                                        name="leavingDate"
                                        onChange={this.onDateTextChange} />
                                <div className="error-message col-md-12 col-lg-9"   style={{ display: this.state.errorMessage.emptyleavingDate ? "contents" : "none",color: "red" }}>
                                    <div style={{paddingLeft:"0px",marginTop:'0px'}}> {this.state.errorMessage.emptyleavingDate}</div>
                                </div>
                            </div>
                            <div className="col-md-4 col-4">
                            <label htmlFor="Days">Days</label>
                                <input 
                                    type="Name" className="form-control" id="days" 
                                    value={days} 
                                    name="days"
                                    onChange={this.onTextChange} 
                                    disabled={true}
                                />
                            </div>
                        </div>
                        </div>
                        {showSucessMessage && newRecord && (
                            <div id="thank_you" className="alert alert-success" style={{ fontSize: '15px'}}>
                                {/* <a onclick="closeForm()" className="close" style={{float: 'right', color: 'black', textDecoration: 'none', fontSize: '24px'}} data-dismiss="alert" aria-label="close">×</a> */}
                                
                                Success! Ship Board Details has been added
                                <button type="button" className="btn-close" data-bs-dismiss="alert" />
                            </div>
                        )}
                        {showSucessMessage && newRecord == false && (
                            <div id="thank_you" className="alert alert-success" style={{ fontSize: '15px'}}>
                                {/* <a onclick="closeForm()" className="close" style={{float: 'right', color: 'black', textDecoration: 'none', fontSize: '24px'}} data-dismiss="alert" aria-label="close">×</a> */}
                                
                                Success! Ship Board Details has been updated
                                <button type="button" className="btn-close" data-bs-dismiss="alert" />
                            </div>
                        )}
                        {showFailureMessage && (
                            <div id="failure" className="alert" style={{fontSize: '15px', backgroundColor: '#e78c8c', borderColor: '#e47779', color: '#730f0f'}}>
                            {/* <a onclick="closeForm()" className="close" style={{float: 'right', color: 'black', textDecoration: 'none', fontSize: '24px'}} data-dismiss="alert" aria-label="close">
                              ×
                            </a> */}
                            <strong>Error!</strong> Oops, something went wrong. Please try again later.
                            <button type="button" className="btn-close" data-bs-dismiss="alert" />
                          </div>
                        )}
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer" style={{padding:'6px 1rem'}}>
                    <button type="submit" onClick={()=>this.onCancelClick()} className="btn Cancel-btn">Cancel</button>
                    <button type="button" onClick={()=>this.saveShipBoardDetails()} className="btn Submit-btn">Save</button>
                    </div>
                </div>
                </div>
            </div>
        );
    }
}

export default addEditShipBoardDetails;